import Axios from 'axios';
import i18n from 'i18next';
import { Store, Action } from 'redux'
import { StoreExt } from 'store';
import config from '../config/config'
import { showMessage } from 'actions/Common';
import { userSignOut } from 'actions/Auth';
import { RootState } from '../model/state';
import { MessageType } from '../model/Message';
import { createCookies } from 'helper/cookies';

export default function configureAxios(store: Store<RootState, Action> & StoreExt) {

  Axios.defaults.baseURL = config.basePublicGatewayUrl;
  Axios.defaults.timeout = 60000;

  // Add a response interceptor
  Axios.interceptors.response.use((response) => {
    //Response

    return response;
  }, function (error) {
    //Response error


    if (window.loggingOut) {
      // logout request failed, possibly had an old token. Ignore the error and proceed.
      delete window.loggingOut;
    } else if (window.isValidatingRegistrationToken) {
      delete window.isValidatingRegistrationToken;
    } else if (error.response && error.response.status === 401) {
      store.dispatch(userSignOut());
    } else if (error.response && error.response.status === 404) {
      store.dispatch(showMessage({
        type: MessageType.ERROR,
        message: i18n.t('error'),
        description: i18n.t('resource_not_found'),
      }));
    } else if (error.response && error.response.status === 403) {
      store.dispatch(showMessage({
        type: MessageType.ERROR,
        message: i18n.t('error'),
        description: i18n.t('resource_not_authorized'),
      }));
    } else if (error && error.code && error.code === 'ECONNABORTED') {
      store.dispatch(showMessage({
        type: MessageType.ERROR,
        message: i18n.t('error'),
        description: i18n.t('timeout_error'),
      }));
    } else if (error.response && error.response.request.responseType === 'arraybuffer'
      && error.response.data.toString() === '[object ArrayBuffer]') {
      // only enters when the error response is of arraybuffer type
      store.dispatch(showMessage({
        type: MessageType.ERROR,
        message: i18n.t('error'),
        description: (JSON.parse(Buffer.from(error.response.data).toString('utf8'))),
      }));

    } else if (!error.response || error.response.status !== 400) {
      const data = (error.response) ? error.response.data : error.data;
      const message = data ? data.message || data.toString() : i18n.t('server_error');

      // store.dispatch(showMessage({
      //   type: MessageType.ERROR,
      //   message: i18n.t('error'),
      //   description: message,
      // }));
      console.error(i18n.t('error'), message);
    }

    return Promise.reject(error);
  });

  //Set initial token from store when loading a direct URL
  if (typeof window !== 'undefined') {
    const token = createCookies().get('token');
    if (token) {
      Axios.defaults.headers.common['Authorization'] = token;
    }
  }
}